const times = {
    "15_Seconds": 15000,
    "1_Minute": 60000,
    "2_Minutes": 120000,
    "5_Minutes": 300000,
    "3_Years": 94608000000,
};
export default times;
